import type { EventEvolutionEvent } from "./EventEvolutionTypes";
import { EventRecordMiniCard } from "./EventRecordMiniCard";
import { getRecordId, getTimeValue } from "./eventEvolutionUtils";
import type { ConjunctionRiskConfig } from "../conjunctions/conjunctionUiUtils";
import type { FormatterMap } from "../../helpers/utils";

interface EventRecordsListProps {
  activeRecordId: string;
  formatters?: FormatterMap;
  records: EventEvolutionEvent[];
  riskConfig?: ConjunctionRiskConfig;
}

export const EventRecordsList = ({
  activeRecordId,
  formatters,
  records,
  riskConfig,
}: EventRecordsListProps) => {
  const sortedRecords = records
    .map((record, index) => ({ index, record }))
    .sort(
      (a, b) =>
        getTimeValue(b.record.executionTime) -
        getTimeValue(a.record.executionTime),
    );

  return (
    <div className="min-h-0 flex-1 space-y-3 overflow-auto pr-1">
      {sortedRecords.map(({ index, record }) => (
        <EventRecordMiniCard
          activeRecordId={activeRecordId}
          formatters={formatters}
          index={index}
          riskConfig={riskConfig}
          key={getRecordId(record, index)}
          record={record}
        />
      ))}
    </div>
  );
};
